//dependencies
import dropdown from "angular-ui-bootstrap/src/dropdown";
import collapse from "angular-ui-bootstrap/src/collapse";
import tabs from "angular-ui-bootstrap/src/tabs";

//services
// replace: \.(component|directive)\("(\w+)",\s*(\w+)\) with: $2,

//components
import creditMemo from "emun.invoice/credit-memo";
import creditMemoDetailsHeader from "emun.invoice/credit-memo-details-header";
import creditMemoLinesTable from "emun.invoice/credit-memo-lines-table";
import invoiceDetailsHeader from "emun.invoice/invoice-details-header";
import invoiceHeading from "emun.invoice/invoice-heading";
import invoiceLinesTable from "emun.invoice/invoice-lines-table";
import invContainer from "emun.invoice/inv/inv-container";
import invDetails from "emun.invoice/inv/inv-details";

//directives
import invDetailsLines from "emun.invoice/inv/inv-details-lines";
import invDetailsActions from "emun.invoice/inv/inv-details-actions";
import invDetailsHeader from "emun.invoice/inv/inv-details-header";
import invLineActions from "emun.invoice/inv/inv-line-actions";
import invLineAttributes from "emun.invoice/inv/inv-line-attributes";
import invLineDetails from "emun.invoice/inv/inv-line-details";
import invLineImageActions from "emun.invoice/inv/inv-line-image-actions";
import invLineImage from "emun.invoice/inv/inv-line-image";
import invLinesHeader from "emun.invoice/inv/inv-lines-header";
import invList from "emun.invoice/inv/inv-list";
import invListGrid from "emun.invoice/inv/inv-list-grid";
import invListCards from "emun.invoice/inv/inv-list-cards";
import invSummary from "emun.invoice/inv/inv-summary";
import invSummaryActions from "emun.invoice/inv/inv-summary-actions";
import parcelPicker from "emun.invoice/parcel-picker/parcel-picker.directive";

//states
import invStates, { getStates } from "emun.invoice/inv/inv.states";

export const dependencies = [dropdown, collapse, tabs];

export const modules = {
  // modals,
};

//const deps = ["emun.auth", "webutils", "webforms", "webmodals", "ui.router"];

export const services = {};

export const components = {
  creditMemo,
  creditMemoEdit: creditMemo,
  creditMemoLinesTable,
  creditMemoHeader: creditMemoDetailsHeader,
  creditMemoDetailsHeader,
  invContainer,
  invDetails,
  invoiceDetailsHeader,
  invoiceHeading,
  invoiceLinesTable
};

export const directives = {
  invDetailsHeader,
  invDetailsLines,
  invDetailsActions,
  invLineActions,
  invLineAttributes,
  invLineDetails,
  invLineImageActions,
  invLineImage,
  invLinesHeader,
  invList,
  invListGrid,
  invListCards,
  invDetailsHeader,
  invSummary,
  invSummaryActions,
  parcelPicker
};

export default {
  modules,
  services,
  dependencies,
  components,
  directives,
  states: {
    ...invStates,
    ...getStates(null, "creditmemo")
  }
};
